var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"snack-bar"}},[(_vm.snackBar.active)?_c('div',{staticClass:"snack-bar"},[_vm._v(" "+_vm._s(_vm.snackBar.text)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }